import k from "../hooks/useSlackConnectionStatus.mjs";
import * as e from "react";
import "swr/infinite";
import { useKnockClient as p } from "../../core/context/KnockProvider.mjs";
import "@knocklabs/client";
import "zustand/shallow";
import { slackProviderKey as S } from "../../core/utils.mjs";
import "../../i18n/context/KnockI18nProvider.mjs";
const c = e.createContext(null), P = ({
  knockSlackChannelId: t,
  tenant: o,
  children: i
}) => {
  const s = p(), {
    connectionStatus: r,
    setConnectionStatus: a,
    errorLabel: n,
    setErrorLabel: l,
    actionLabel: m,
    setActionLabel: u
  } = k(s, t, o);
  return /* @__PURE__ */ e.createElement(c.Provider, { key: S({
    knockSlackChannelId: t,
    tenant: o,
    connectionStatus: r,
    errorLabel: n
  }), value: {
    connectionStatus: r,
    setConnectionStatus: a,
    errorLabel: n,
    setErrorLabel: l,
    actionLabel: m,
    setActionLabel: u,
    knockSlackChannelId: t,
    tenant: o
  } }, i);
}, L = () => {
  const t = e.useContext(c);
  if (t === void 0)
    throw new Error("useKnockSlackClient must be used within a KnockSlackProvider");
  return t;
};
export {
  P as KnockSlackProvider,
  L as useKnockSlackClient
};
//# sourceMappingURL=KnockSlackProvider.mjs.map
